module.exports = __WEBPACK_EXTERNAL_MODULE_53__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-DSDEditor"
// module id = 53
// module chunks = 0